interface IBlobImageProps extends React.ImgHTMLAttributes<unknown> {
  url: string;
}

export default function BlobImage({ url, ...imgProps }: IBlobImageProps): JSX.Element {
  return <img src={url} loading="lazy" {...imgProps} />;
}
